import { useSearchParams } from 'react-router-dom';
import { Tabs, Tag } from 'antd';
import { useMaasCredentials } from './hooks/useMaasCredentials';
import { useSecrets } from './hooks/useSecrets';
import { useAgentTokens } from '@/modules/tokens';
import { TokenType } from '@/proto/agentplatform/v2/token_pb';
import ModelCredentialsTab from './ModelCredentialsTab';
import ObjectStorageCredentialsTab from './ObjectStorageCredentialsTab';
import WebSocketTokenTab from './WebSocketTokenTab';
import './credentials.css';

/** Platform · 凭证管理（3 Tab：模型凭证 / Agent API Token / WebSocket Token）
 *  对齐 /Users/wwxq/Downloads/genui-demo-main 2/apps/platform-react/src/pages/CredentialsView.tsx */
export default function CredentialsPage() {
  const [sp, setSp] = useSearchParams();
  const rawKey = sp.get('tab') || 'creds';
  // Agent API Token tab 已隐藏，历史 URL 带 tab=agent-token 时回退到默认 tab
  const activeKey = rawKey === 'agent-token' ? 'creds' : rawKey;

  // Tab badges：仅取 total，避免每次切换都重拉。
  const { data: credsRes } = useMaasCredentials();
  const { data: ossRes } = useSecrets(1, 1);
  const { data: wsTokensRes } = useAgentTokens(TokenType.WEBSOCKET, 1, 1);

  const credsCount = credsRes?.total ?? credsRes?.items.length ?? 0;
  const ossCount = ossRes?.total ?? 0;
  const wsCount = wsTokensRes?.total ?? 0;

  return (
    <div className="pp-page creds-page">
      <header className="pp-head">
        <div>
          <h2>凭证管理</h2>
          <p>统一托管模型 API Key、对象存储凭证、WebSocket 长连接 token</p>
        </div>
      </header>

      <Tabs
        activeKey={activeKey}
        onChange={(k) => {
          const next = new URLSearchParams(sp);
          next.set('tab', k);
          setSp(next, { replace: true });
        }}
        className="pp-subtabs cred-tabs"
        items={[
          {
            key: 'creds',
            label: (
              <>
                模型凭证{' '}
                <Tag color="default" bordered={false}>
                  {credsCount}
                </Tag>
              </>
            ),
            children: <ModelCredentialsTab />,
          },
          {
            key: 'oss-cred',
            label: (
              <>
                对象存储凭证{' '}
                <Tag color="default" bordered={false}>
                  {ossCount}
                </Tag>
              </>
            ),
            children: <ObjectStorageCredentialsTab />,
          },
          {
            key: 'ws-token',
            label: (
              <>
                WebSocket Token{' '}
                <Tag color="default" bordered={false}>
                  {wsCount}
                </Tag>
              </>
            ),
            children: <WebSocketTokenTab />,
          },
        ]}
      />
    </div>
  );
}
